import { render, staticRenderFns } from "./CustomAmount.vue?vue&type=template&id=47ea9d46&"
import script from "./CustomAmount.vue?vue&type=script&lang=js&"
export * from "./CustomAmount.vue?vue&type=script&lang=js&"
import style0 from "./CustomAmount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports